import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, HyattEvent } from "../../../services/index";
import { JGRNService } from "../../../services/jgrn.service";
declare var google;

@Component({
  selector: "bit-fabric-stock",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "bitFabricStock.html",
})
export class bitFabricStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  design_no: any;
  filter = {
    party_name: "",
    jgrn_from_date: "",
    jgrn_to_date: "",
    finyear: "",
    fab_design: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "jgrn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  data: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  jgrnList: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private jgrn: JGRNService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    public event: HyattEvent
  ) {
    this.event.jgrnSaved$.subscribe((val: any) => {
      this.getBitList();
    });
  }
  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      jgrnList: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  getColumns() {
    this.columns = [
      {
        name: "S.No",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref no",
        prop: "bit_ref_no",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        cellClass: "text-center",
      },
      {
        name: "Bit Date",
        prop: "jgrn_date_formatted",
        headerClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Total Mtrs",
        prop: "total_mtr",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Total Bits",
        prop: "total_bits",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Total Amount",
        prop: "grand_total",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      /*  { name: 'JGRN No', prop: 'ref_no', cellClass: 'text-right', headerClass: 'text-center', minWidth: 80, maxWidth: 80, width: 80 }, */
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        headerClass: "text-center",
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Print Barcode",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        headerClass: "text-center",
        width: 100,
        sortable: false,
        cellTemplate: this.printTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_name").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getBitList();

  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    this.filter.jgrn_from_date = "";
    this.filter.jgrn_to_date = "";
    this.filter.fab_design = "";
    this.applyFilter();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.getBitList();
    });
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getBitList();
  }

  addEditBit(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getBitList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD BIT STOCK",
          title: "ADD BIT STOCK",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitStock",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT BIT STOCK",
          title: "EDIT BIT STOCK",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitStock",
        },
      };
    } else if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW BIT STOCK",
          title: "VIEW BIT STOCK",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditBitStock",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  getBitList(): void {
    if (this.filter.jgrn_from_date == "") {
      this.filter.jgrn_from_date == "";
    } else {
      this.filter.jgrn_from_date = this.datePipe.transform(
        this.filter.jgrn_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.jgrn_to_date == "") {
      this.filter.jgrn_to_date == "";
    } else {
      this.filter.jgrn_to_date = this.datePipe.transform(
        this.filter.jgrn_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_name: this.filter.party_name,
      jgrn_from_date: this.filter.jgrn_from_date,
      jgrn_to_date: this.filter.jgrn_to_date,
      finyear: this.filter.finyear,
      fab_design: this.filter.fab_design,
      stock_type: "BIT",
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.jgrn.getJGrnList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.totCnt;
      that.jgrnList = res.data;
    });
  }
  // loadeditJGRNList(row) {
  //   let jgrn_id = row.jgrn_id;
  //   let params = {
  //     jgrn_id: jgrn_id,
  //   };
  //   this.jgrn.getEditJGRNList(params).then((res: any) => {
  //     this.data.jgrnList = res.data;
  //     // this.calcTotal();
  //     // this.calcQty();
  //     this.clickPrint(row, res.data);
  //   });
  // }

  loadeditJGRNPrintList(rows) {
    let jgrn_id = rows.jgrn_id;
    let params = {
      jgrn_id: jgrn_id,
      stock_type: "BIT",
    };
    let that = this;
    that.jgrn
      .getEditBitJGRNList(params)
      .then((res: any) => {
        that.data.jgrnList = res.data;
        var row = res.data[0];
        // that.calcTotal();
        // that.calcQty();
        if (row.jgrnType == "BIT") {
          swal({
            title:
              "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
          })
            .then(() => {
              that.clickPrint(row, res.data);
            })
            .catch(() => {});
        } else {
          swal({
            title:
              "Please ensure that large Sticker roll (Bulk Roll) was inserted...",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
          })
            .then(() => {
              that.clickPrint(row, res.data);
            })
            .catch(() => {});
        }
      })
      .catch(() => {});
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn
      .jgrnprint(params)
      .then(function (res: any) {})
      .catch(() => {});
  }

  deleteJGrn(row: any): void {
    let that = this;
    row["tabevent"] = undefined;
    swal({
      title: "Are you sure to delete this JGrn Details?",
      text:
        "You will not be able to recover this JGrn" + " " + row["ref_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.jgrn.deleteJGrn(row).then(function (res: any) {
          that.loadingIndicator = false;
          that.getBitList();
          let errtype = "success",
            errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }

          that.toasterService.pop({
            bodyOutputType: 1,
            type: errtype,
            title: errtype.toUpperCase(),
            body: errmsg,
          });
        });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitStock/bitFabricStock.ts